var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-start",staticStyle:{"max-width":"100%"},attrs:{"fluid":"","pa-0":"","fill-height":""}},[_c('div',{staticClass:"d-flex flex-column flex-grow-1 fill-height"},[_c('HistoryTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }